import { Outlet } from 'react-router'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { BackgroundProvider } from '@tribeplatform/react-ui-kit/BackgroundContext'

import { Preview } from '../../Editor/Preview/Preview.js'

export function AppearanceRootRoute() {
  return (
    <div className="flex h-full">
      <BackgroundProvider backgroundType="surface">
        <Outlet />
      </BackgroundProvider>
      <div className="flex-1 overflow-hidden">
        <Preview />
      </div>
    </div>
  )
}

export function AppearanceBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link href={adminRoutes.design.appearance.root}>
      <T id="Generics.Appearance" defaultMessage="Appearance" />
    </Link>
  )
}
